import LegalLayout from './landing/LegalLayout';

function DataDeletion() {
  return (
    <LegalLayout title="Data Deletion Instructions" subtitle="for EFSoft">
      <p>
        EFSoft respects your right to control your personal data. To have your
        data deleted from our systems, follow these steps.
      </p>

      <section>
        <h2>Submit Your Request</h2>
        <p>
          Email us at{' '}
          <a href="mailto:emil.filip@efsoft.co.uk">emil.filip@efsoft.co.uk</a>{' '}
          with your full name, any associated account or reference information,
          and a clear statement requesting the deletion of your personal data.
        </p>
      </section>

      <section>
        <h2>Verification Process</h2>
        <p>
          We may ask you to verify your identity, so we can confirm that the
          deletion request really comes from you.
        </p>
      </section>

      <section>
        <h2>Processing Your Request</h2>
        <p>
          Once we have verified your identity, we will delete your data from our
          active systems. We may keep some data where the law requires it, or
          for accounting or regulatory purposes.
        </p>
      </section>

      <section>
        <h2>Confirmation</h2>
        <p>
          We will email you once your data has been deleted.
        </p>
      </section>

      <section>
        <h2>Important Considerations</h2>
        <ul>
          <li>
            Deleting your data may affect your access to some services on our
            website.
          </li>
          <li>
            The process can take up to 30 days, depending on how complex your
            request is and on our legal obligations.
          </li>
        </ul>
      </section>

      <div className="legal-callout">
        <p>
          If you have questions about deleting your data, contact us at{' '}
          <a href="mailto:emil.filip@efsoft.co.uk">emil.filip@efsoft.co.uk</a>
        </p>
      </div>
    </LegalLayout>
  );
}

export default DataDeletion;
